module.exports = __webpack_public_path__ + "img/swiper-img4-over.8563e7da.png";